import { Grid, Typography } from "@mui/material";

import { FairPaySurveyPartnership } from "features/FairPaySurvey/schemas";

const styles = {
  badge: {
    my: 2,
    background: "white",
    p: 5,
    border: `1px solid #DFDFDF`,
    borderRadius: "20px",
  },
  descriptionLargeText: {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: 600,
    mb: 3,
  },
  descriptionText: { textAlign: "center", fontSize: "18px", fontWeight: 600 },
  yourRange: {
    p: 2,
    borderRadius: "13px",
    background: "#F7EE6F",
    textAlign: "center",
  },
  typicalRange: {
    p: 2,
    borderRadius: "13px",
    background: "#ECEAE5",
    textAlign: "center",
  },
  rangeTitle: {
    opacity: "60%",
    mb: 0.5,
  },
  rangeValue: {
    fontWeight: 500,
    color: "#151F16",
    fontSize: "20px",
  },
};

export default function SingleBrandBreakdown({
  surveyPartnership,
}: {
  surveyPartnership: FairPaySurveyPartnership;
}) {
  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionLargeText}>
          {surveyPartnership.brandName}
        </Typography>
      </Grid>
      <Grid container xs={12} item gap={1} sx={{ mb: 4 }}>
        <Grid item xs sx={styles.yourRange}>
          <Typography sx={styles.rangeTitle}>Your rate</Typography>
          <Typography sx={styles.rangeValue}>
            ${surveyPartnership.yourRate.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs sx={styles.typicalRange}>
          <Typography sx={styles.rangeTitle}>Typical range</Typography>
          <Typography sx={styles.rangeValue}>
            {surveyPartnership.typicalRange}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionText}>
          {surveyPartnership.rangeComparison}
        </Typography>
      </Grid>
    </Grid>
  );
}
